import React from 'react';
import { Button, useSession } from '@cordata/buffet';

import { useIdentityPage } from '~/utils/identity/page';

const PrintHeader = () => {
  const {
    printSpec,
    print,
    isPrinting,
    resetPrint,
  } = useIdentityPage();
  const { debugMode } = useSession();

  const reshapePrintSpec = () => {
    return Object.keys(printSpec).reduce((result, k) => {
      if (k !== 'auditAs') {
        const item = printSpec[k];

        result.push({
          title: k,
          ...item,
        });
      }

      return result;
    }, []);
  };

  return (
    <>
      <div>
        { debugMode && (
          <>
            <h3>To Be Printed:</h3>
            <ul>
              {reshapePrintSpec().map(spec => (
                <li key={spec.title}>
                  {spec.title}
                  <ul>
                    {spec.pageItems?.map(item => (
                      <li key={`${spec.title}-${item.title}`}>
                        {item.title}
                        <ul>
                          {item.specificItem && <li>{item.specificItem}</li>}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </>
        )}
        <div className="d-print-none mb-3">
          <div className="d-flex mt-2 mr-auto ml-auto justify-content-center">
            <Button
              outline
              color="tertiary"
              size="sm"
              icon="times"
              onClick={resetPrint}
            >
              cancel
            </Button>

            <Button
              disabled={isPrinting}
              size="sm"
              icon="print"
              onClick={print}
            >
              print
            </Button>
          </div>

          <h6 className="font-weight-bold">
            Follow the below steps to save page as a PDF:
          </h6>

          <ul>
            <li>Click on the Print button above.</li>
            <li>A PDF of the data will open in a new tab.</li>
            <li>In the PDF viewer, click the download / save as button.</li>
            <li>Once saved, you may close the tab and return to the application.</li>
          </ul>

          <h6 className="font-weight-bold">
            Emailing the PDF:
          </h6>
          <p>
            This document contains sensitive or confidential information. It is your responsibility
            to ensure that it leaves your agency securely. You should encrypt the email or use a
            secure mail service to distribute it to recipients.
          </p>
          <br />
          <p className="mb-0 text-muted">
            Please contact <a href="mailto:support@cordatahealth.com?subject=Cordata IDENTITY- Support Request">support</a> if
            you need additional assistance.
          </p>
        </div>
      </div>
      <hr className="d-print-none print-hr border-top-2" />
    </>
  );
};

export default PrintHeader;
